import { useMemo } from "react";
import { CircleDollarSign } from "lucide-react";
import { Link } from "react-router-dom";
import { useNewestRecordFlash } from "@/hooks/useNewestRecordFlash";
import { newestFirst } from "@/utils/sortHistory";

const label = (value) => (value || "unbilled").replaceAll("_", " ");

export const ProjectBillingPanel = ({
  canAccessBilling,
  invoices,
  onEditInvoice,
  onNewInvoice,
  summary,
}) => {
  const sortedInvoices = useMemo(() => newestFirst(invoices), [invoices]);
  const flashInvoiceId = useNewestRecordFlash(sortedInvoices);
  if (!canAccessBilling) {
    return null;
  }
  return (
    <section
      className="command-panel command-billing-panel"
      data-testid="project-invoice-section"
    >
      <div className="command-panel-heading">
        <div>
          <span className="operations-kicker">Billing</span>
          <h2>Project invoices</h2>
        </div>
        <div>
          <button
            data-testid="project-invoice-new-button"
            onClick={onNewInvoice}
            type="button"
          >
            New invoice
          </button>
          <Link data-testid="command-open-billing" to="/billing">
            Open Billing
          </Link>
        </div>
      </div>
      <div className="command-billing-status">
        <CircleDollarSign size={18} />
        <div>
          <span>Current invoice status</span>
          <strong>{label(summary.status)}</strong>
        </div>
      </div>
      <div className="command-billing-metrics">
        <span>
          Invoices <strong>{summary.invoice_count || 0}</strong>
        </span>
        <span>
          Invoiced <strong>{summary.invoiced_count || 0}</strong>
        </span>
        <span>
          Paid <strong>{summary.paid_count || 0}</strong>
        </span>
      </div>
      {invoices.length ? (
        sortedInvoices.slice(0, 3).map((invoice) => (
          <button
            className={`command-billing-row${invoice.id === flashInvoiceId ? " newest-record-flash" : ""}`}
            data-testid={`project-invoice-open-${invoice.id}`}
            key={invoice.id}
            onClick={() => onEditInvoice(invoice)}
            type="button"
          >
            <strong>{invoice.invoice_number || "Invoice pending"}</strong>
            <span>
              {label(invoice.status)} · {invoice.payment_status || "unpaid"}
            </span>
          </button>
        ))
      ) : (
        <p className="command-empty-state" data-testid="project-invoice-empty">
          No invoices are linked to this Project.
        </p>
      )}
    </section>
  );
};